import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipComponent, TooltipContainerDirective } from './tooltip.component';
import { TooltipDirective } from './tooltip.directive';



@NgModule({
  declarations: [TooltipComponent, TooltipDirective, TooltipContainerDirective],
  imports: [
    CommonModule
  ],
  exports: [
    TooltipComponent, TooltipDirective, TooltipContainerDirective
  ],
  entryComponents: [
    TooltipComponent
  ]
})
export class TooltipModule { }
